exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    display: grid;\n    padding: 0;\n}\n\n.grid-content {\n    display: grid;\n    grid-template-columns: auto;\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n    grid-auto-flow: row;\n    margin-bottom: 10px;\n}\n\n.pcard {\n    display: grid;\n    grid-template-columns: auto;\n    grid-auto-flow: row;\n}\n\n@media only screen and (min-width: 400px) {\n    .pcard {\n        grid-template-columns: auto auto;\n    }\n}\n\n@media only screen and (min-width: 800px) {\n    .pcard {\n        grid-template-columns: auto auto auto;\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/comparison/settings/comparison.settings.component.css
// module id = ./src/app/components/comparison/settings/comparison.settings.component.css
// module chunks = main